// This import loads the firebase namespace along with all its type information.
import ProcessedMedia from './processed-media-model'

export async function load_processedMedias(): Promise<ProcessedMedia[]> {
  throw 'Not implemented'
}

export async function delete_processedMedia(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_processedMedia(): Promise<ProcessedMedia> {
  throw 'Not implemented'
}
